import { TrackJS } from 'trackjs';
import { useSiteContentStore } from '~/stores/siteContent';

export function useSystemText() {
  const siteContent = useSiteContentStore();

  const systemText = (key: string, variable: string | null = null, variables: string[] | null = null): string => {
    let value: string = '';

    if (key) {
      if (systemTextExists(key)) {
        value = siteContent.systemTextLowerCasedKeys.get(key.toLowerCase()) ?? '';
      } else {
        TrackJS.track(`systemText key not found: ${key}`);
        return '';
      }
    }

    if (variables) return variables.reduce((newValue, v) => newValue.replace('%s', v), value);

    return variable ? value.replace(/%s/g, variable) : value.replace(/%s/g, '');
  };

  const systemTextExists = (key: string): boolean => {
    if (key) {
      return siteContent.systemTextLowerCasedKeys.has(key.toLowerCase());
    }
    return false;
  };

  return { systemText, systemTextExists };
}
